import { Component, Input } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { IQRPredisposition } from "@gloria-public/home/domain/interfaces/home.interface";

@Component({
  selector: "app-qr-predisposition",
  templateUrl: "./qr-predisposition.component.html",
  styleUrls: ["./qr-predisposition.component.scss"],
})
export class QRPredispositionComponent {
  @Input() qrpredisposition!: IQRPredisposition;
  @Input() riskId!: string;

  constructor(
    private router: Router,
    public snackBar: MatSnackBar
  ) {}

  /**
   * Navigate to questionnaire
   */
  public openQuestionnaire(): void {
    // redirection to the optionnal /completed done on that page
    this.router.navigate(["/risks", this.riskId, "questionnaires", this.qrpredisposition.questionnaire]);
  }
}
